<!-- terminos -->
<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent>
      <v-card class="np-card">
        <v-card-title class="np-hero py-3">
          <div class="d-flex align-center" style="gap: 12px;">
            <v-avatar color="white" size="40" class="elevation-1">
              <v-icon color="deep-orange darken-3"> mdi-account </v-icon>
            </v-avatar>
            <div>
              <div class="text-h6">Terminos y condiciones:</div>
              <div class="text-body-2 opacity-80"> 
              </div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="ma-0 pa-0" style="max-height: 520px; overflow-y: auto;">
          <v-progress-linear indeterminate v-if="loading" /> 
          <iframe :srcdoc="terminos.contenido" width="100%" height="480" frameborder="0"></iframe>
          <iframe v-show="false" ref="miIframe" :srcdoc="terminos.contenido" width="100%" height="480" frameborder="0"></iframe>
        </v-card-text>

        <!-- <span> {{ enlace }} </span> -->
         <div class="mr-4 mt-4 pb-0 purple--text text-right"> <b>Correo del estudiante:</b> {{ ins?.estudiante?.email }}, {{ correos_comas }} </div>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="green" text @click="generateReport()">PDF</v-btn> -->
          <!-- <v-btn color="green" text @click="copyenlace()">Copiar Link</v-btn> -->
          <v-btn color="green" text @click="enviar_correo()">Enviar al correo del estudiante</v-btn>
          <v-btn color="grey" text @click="cerrar()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
import { body_email } from './terminos_email_body';
import { terminos_condicion } from './utils';  

  export default {
    components:{ },
    data() {
      return {
        loading: false,
        dialog: false,
        terminos: {},
        ins: {},
        enlace:'',
        correos_comas: '',
      };
    },
    methods: {
      // xins es contacto, si viene de contactos
      // xins es inscripcion, si viene de mis inscripciones *Este es el valido
      async openmodal(xins) { 
        this.ins = xins;
        this.enlace = ''
        this.correos_comas = ''
        this.dialog = true; 

        if(!this.ins.programa && this.ins.xprograma_id){
          this.loading = true
          const qs = gql`query{ getPrograma(id: ${this.ins.xprograma_id}) {id nombre_compuesto} }`;
          const res = await this.$apollo.query({ query: qs }).then(({ data }) => (data.getPrograma ? data.getPrograma : { programa_modulos: [] }));
          this.ins.programa = res 
          this.loading = false
        }

        if(!this.ins.programa) {
          this.$root.$notify.show(`No se pudo obtener informacion del programa`, {color:'red',x: 'center', y:'bottom', timeout:12000});
          this.dialog = false; 
          return
        }

        this.fake_email_in_test()
        this.generateLink();
        // por el momento todavia no hay correos de los gerentes
        // this.get_sede(this.ins.programa.sede.id)
        this.listar();
      },
      async listar(){
        this.loading = true;
        let unidad_negocio_id = this.$store.state.CARGO.sede.unidad_negocio;
        const q = {
          unidad_negocio: unidad_negocio_id
        }
        this.loading = false;
        const r = await terminos_condicion(q)
        this.terminos = r 
      },
      async generateLink(){
        const e = this.ins.estudiante;
        if(!e.seg_apellido) e.seg_apellido = ''
        // window.console.log('inssss', this.ins);
        if(!this.ins.programa) {
          this.dialog = false; 
          this.$root.$notify.show(`No se pudo obtener informacion del programa actual.`, {color:'red',x: 'center', y:'bottom', timeout:12000});
          return
        }
        
        const contactoid = null;
        const persona_id = e.id;
        const host = window.location.hostname
        const unidad = this.$store.state.CARGO.sede.unidad_negocio;
        const estudiante_id = e.id
        const estudiante_nombre = `${e.nombres} ${e.pri_apellido} ${e.seg_apellido}`.trim();
        const programa_id = this.ins.programa.id
        const programa_nombre = this.ins.programa.nombre_compuesto
        const inscripcion_id = this.ins.id
        
        const raw = [contactoid, persona_id, host, unidad, estudiante_id,estudiante_nombre,programa_id,programa_nombre,inscripcion_id].join('|')
        const token = btoa(String.fromCharCode(...new TextEncoder().encode(raw))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')

        
        const mapa = {
          1: `https://formulario.esam.edu.bo/index_terms.html?t=${token}`,
          5: `https://formulario.esamlatam.com/index_terms.html?t=${token}`,
          14: `https://formulario.ispi.edu.pa/index_terms.html?t=${token}`,
          15: `https://formulario.upi.edu.pa/index_terms.html?t=${token}`,
        }
        
        let link = mapa[unidad]
        if(!link) link = mapa[1]

        // let link = `http://localhost:5007/index_terms.html?t=${token}`

        let apidev = process.env.VUE_APP_GRAPHQL;
        if( apidev.includes("apidev") ){
          link = link.replaceAll('formulario.','formulariotest.')
        }
        this.enlace = link; 
      },
      async copyenlace(){ 
        await navigator.clipboard.writeText(this.enlace);
        document.execCommand('copy');
        this.$root.$notify.show(`Link copiado, ahora envialo al contacto para que acepte.`, {color:'green',x: 'center', y:'bottom',});
      },
      /*generateReport() {
        
        const iframe = this.$refs.miIframe
        
        const doc =
        iframe.contentDocument ||
        iframe.contentWindow.document;
        
        const body = doc.querySelector('body')
        if (body) {
          body.style.margin = '0'
          body.style.padding = '2em'
        }
        this.$refs.miIframe.contentWindow.print()
      },*/
      fake_email_in_test(){
        const apidev = process.env.VUE_APP_GRAPHQL;
        if( apidev.includes("apidev") ){
          this.ins.estudiante.email = "sladiadev@gmail.com";
        }
      },
      async get_sede(idsede){
        // window.console.log('inssss', this.ins);
        
        const sql = gql`query{ getSede(id:${idsede}){id,nombre,correos{tipo direccion}} }`
        const r = await this.$apollo.query({query: sql}).then(({data}) => data?.getSede).catch((error) => error);
        window.console.log('getsede', r);
        if(r && r.correos){
          if(!r.correos || r.correos.length == 0){
            this.$root.$notify.show(`Se necesita que la sede tenga configurado el correo del gerente para enviar copia a su correo.`, {color:'red',x: 'center', y:'bottom', timeout:4000});
            this.dialog = false;
            return
          }
          const correos = r.correos || []
          this.correos_comas = correos.map(c => c.direccion).join(',')
        }else{
          this.$root.$notify.show(`algo salio muy mal: `+r, {color:'red',x: 'center', y:'bottom', timeout:4000});
          this.dialog = false;
        }
        
      },

      // esta funcion se llama desde fuera, en el momento de generar el primer recibo de un prospecto
      async externo_generar_enviar_correo(xins,xcorreos_sede){
        this.correos_comas = '';
        if(xcorreos_sede && xcorreos_sede.length){
          this.correos_comas = xcorreos_sede.map(c => c.direccion).join(',')
        }
        this.ins = xins;
        this.fake_email_in_test()
        this.generateLink()
        this.enviar_correo();
      },
      async enviar_correo(){
        const unidad = this.$store.state.CARGO.sede.unidad_negocio;
        if( unidad != 1 && unidad != 5 && unidad != 10){
          return;
        }
        window.console.log('=============================================');
        window.console.log('enviar_correo:::', this.ins);
        window.console.log('correos_comas:::', this.correos_comas);
        window.console.log('=============================================');
        
        let correo = this.ins.estudiante.email;
        if(this.correos_comas) correo = `${correo},${this.correos_comas}`
        let inscripcion_id = this.ins.id; 
        let xestudiante = window.Object.assign({}, this.ins.estudiante);
        xestudiante.nombres = xestudiante.nombres.replace(this.ins.estudiante.pri_apellido, '');
        xestudiante.nombres = xestudiante.nombres.replace(this.ins.estudiante.seg_apellido, '');
        xestudiante.nombres = (xestudiante.nombres + '').replace(/\s+/g, ' ');
        xestudiante.nombres = (xestudiante.nombres + '').trim();

        let nombre_estudiante = `${xestudiante.nombres} ${xestudiante.pri_apellido} ${xestudiante.seg_apellido}`.trim().toUpperCase();
        const nombre_programa = this.ins.programa.nombre_compuesto;
        if(!correo){          
          this.$root.$notify.show(`No hay correo del estudiante, no se pudo enviar los terminos y condiciones`, {color:'red',x: 'center', y:'bottom', timeout:12000});
          return;
        }
        const body_html = body_email(this.enlace, nombre_programa,nombre_estudiante);
        const graphql = JSON.stringify({
          query: `mutation enviar_terminos_email {
            enviar_terminos_email(input:{
              inscripcion_id:${Number(inscripcion_id)},
              correo:${JSON.stringify(correo)},
              body_html:${JSON.stringify(body_html)}
            })
          }`,
        });

        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: graphql, 
        };

        this.$root.$notify.show(`Enviando terminos y condiciones ${correo} ....`, {color:'cyan',x: 'center', y:'bottom', timeout:13000});
        const res = await fetch(process.env.VUE_APP_PROSPECTOS_API, requestOptions)
          .then((response) => response.json())
          .then((result) => result.data || result)
          .catch((error) => error);

        window.console.log('correo::::', res);
        if(res && res.enviar_terminos_email){
          const r = JSON.parse(res.enviar_terminos_email)
          let msg = r.message
          this.$root.$notify.show(`Terminos y condiciones ${msg} -> ${correo}`, {color:'green',x: 'center', y:'bottom', timeout:13000});
        }
          

      },
      cerrar(){
        this.dialog = false
      }
    },
    mounted() {}, 
  };
</script>
